const ticketActionCreators = (dispatch: <T>(action: any) => T) =>
  Object.assign({}, {});

export default ticketActionCreators;
